import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMobileLayout from 'Hooks/useMobileLayout';
import { FDStack } from '@facet-wealth/design';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import React from 'react';

const useStyles = buildUseStyles('TaxStrategyDetailsSkeleton', (theme) => ({
  skeleton: {
    borderRadius: theme.radius.md,
  },
}));

const TaxStrategyDetailsSkeleton = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const isMobile = useMobileLayout();
  return (
    <FDStack direction={'column'} alignItems={'center'} spacing={6} width={'100%'}>
      <FDStack direction={'column'} spacing={2} alignItems={'center'} width={'100%'}>
        <Skeleton className={classes.skeleton} variant={'rect'} width={250} height={65} />
        <Skeleton className={classes.skeleton} variant={'rect'} width={isMobile ? '100%' : 550} height={40} />
      </FDStack>
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={140} />
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={110} />
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={400} />
      <Skeleton className={classes.skeleton} variant={'rect'} width={'100%'} height={190} />
    </FDStack>
  );
};

TaxStrategyDetailsSkeleton.defaultProps = {};

TaxStrategyDetailsSkeleton.propTypes = {};

export { TaxStrategyDetailsSkeleton };
